<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t(dialogProp.readonly
            ? 'Просмотр позиции'
            : 'Редактирование позиции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-info-fix
            v-if="dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :position-info="position"
            :readonly="dialogProp.readonly"
            :hide-delivery-condition="hideDeliveryCondition"
            :validated="updatePosition" />
        <position-info-differential
            v-else
            ref="position"
            :position-info="position"
            :readonly="dialogProp.readonly"
            :hide-delivery-condition="hideDeliveryCondition"
            :validated="updatePosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t(dialogProp.readonly
            ? 'Закрыть'
            : 'Отмена') }}
        </v-btn>
        <v-btn
            v-if="!dialogProp.readonly"
            id="continueOperationBtn"
            class="ma-1"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionInfoFix from './PositionInfoFix.vue'
  import PositionInfoDifferential from './PositionInfoDifferential.vue'
  import GeneralError from '../common/GeneralError.vue'
  import { PREMIUM_TYPES, DICTIONARY_TYPES } from '@/constants/business'
  import { LOT_POSITIONS_MANAGEMENT, DICTIONARIES } from '@/constants/store'
  import { mapActions, mapState } from 'vuex'

  export default {
    components: {
      GeneralError,
      PositionInfoFix,
      PositionInfoDifferential
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: {
              lotId: null,
              premiumType: null,
              incotermId: null
            },
            positionId: null,
            readonly: false,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        position: state => (state[LOT_POSITIONS_MANAGEMENT.STATE.CURRENT_POSITION] || {})
      }),
      ...mapState(DICTIONARIES.NAMESPACE, {
        incoterms: state => state[DICTIONARY_TYPES.INCOTERMS] || []
      }),
      hideDeliveryCondition () {
        return !!this.incoterms
        .find(i => i.incotermId === this.dialogProp.lot.incotermId)?.hasBasises
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.dialogProp.lot.premiumType ||
          !vm.dialogProp.lot.lotId ||
          !vm.dialogProp.positionId) {
          vm.showErrorAction({
            message: vm.$t('Данные для изменения позиции указаны некорректно.')
          })
          return
        }
        vm.getPositionInfo()
        if (!vm.incoterms.length) {
          vm.getIncoterms()
        }
      })
    },
    methods: {
      ...mapActions(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        getPositionInfoAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.GET_POSITION_INFO,
        updatePositionAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.UPDATE_POSITION,
        clearPositionInfoAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.CLEAR_POSITION_INFO
      }),
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getBusinessDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_BUSINESS_DICTIONARY_ITEMS,
        clearDictionaryItemsAction: DICTIONARIES.ACTIONS.CLEAR_DICTIONARY_ITEMS
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.hideErrorAction(),
            this.clearPositionInfoAction(),
            this.clearDictionaryItemsAction(DICTIONARY_TYPES.INCOTERMS)
          ])
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getPositionInfo: async function () {
        try {
          this.isLoading = true
          await this.getPositionInfoAction({
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType,
            premiumType: this.dialogProp.lot.premiumType,
            positionId: this.dialogProp.positionId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getIncoterms: async function () {
        try {
          this.isLoading = true
          await this.getBusinessDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.INCOTERMS
          })
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      updatePosition: async function (position) {
        await this.updatePositionAction({
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          premiumType: this.dialogProp.lot.premiumType,
          positionId: this.dialogProp.positionId,
          position
        })
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
